import { cAF, rAF } from '../../utils'

export const useGridWheel = (
  onWheelDelta,
  rowHeight,
  scrollPreventDefault = false
) => {
  let frameHandle = null
  let xOffset = 0
  let yOffset = 0

  let isPreventDefault = true
  let time
  let preY = null

  const onWheel = (e) => {
    let { scrollTop, clientHeight, scrollHeight } = e.currentTarget
    cAF(frameHandle)
    let x = e.deltaX
    let y = e.deltaY
    if (Math.abs(x) > Math.abs(y)) {
      y = 0
    } else {
      x = 0
    }
    if (!(Math.abs(y) % rowHeight)) {
      y = y / 3
    }

    if (e.shiftKey && y !== 0) {
      x = y
      y = 0
    }

    xOffset += x
    yOffset += y

    const isBottom = scrollHeight - scrollTop === clientHeight
    const isTop = scrollTop === 0
    const isXScroll = y === 0 && x !== 0
    // 兼容当某个方向到达顶部或底部时，重置isPreventDefault
    if (scrollPreventDefault || (isTop && y > preY) || (isBottom && y < preY)) {
      isPreventDefault = true
    }
    preY = y
    // 没有到达底部，不触发外部滚动
    if (isPreventDefault || isXScroll) {
      e.preventDefault()
    }

    if (isBottom || isTop) {
      time = setTimeout(() => {
        isPreventDefault = false
      }, 20)
    } else {
      isPreventDefault = true
      if (time) {
        clearTimeout(time)
        time = null
      }
    }

    frameHandle = rAF(() => {
      onWheelDelta(xOffset, yOffset)
      xOffset = 0
      yOffset = 0
    })
  }

  return {
    onWheel,
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/virtual-grid/use-grid-wheel.js